<template lang="pug">
  .container
    .rows.wrapRWD
      .tab(v-for="(tab, index) in tabs", v-on:click="setTab(index)", :class="{'active': currentTab === index}") {{ tab.title }}
    .panel(v-html="getContent()")
</template>

<script>
export default {
  name: 'TabPanel',
  data () {
    return {
      currentTab: 0
    }
  },
  props: {
    tabs: {
      type: Array,
      required: true
    }
  },
  methods: {
    setTab (index) {
      this.currentTab = index
    },
    getContent () {
      return this.tabs[this.currentTab].content
    }
  }
}
</script>

<style lang="sass" scoped>

.tab
  +fs($ta: center)
  padding: 20px
  margin: 0
  flex: 1 1 auto
  width: 0
  border-bottom: 3px solid $c-light-grey
  cursor: pointer
  &.active
    border-color: $c-primary

.panel
  +fs($lh: 1.8)
  padding: 30px
  background-color: rgba($c-light-grey, .3)
  margin-bottom: 20px

</style>



// WEBPACK FOOTER //
// src/components/TabPanel.vue